"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerBook = void 0;
const lodash_1 = __importDefault(require("lodash"));
const assignment_1 = require("../assignment");
const common_1 = require("../common");
const entries_1 = require("../entries");
class AnswerBook {
    constructor(data) {
        this.assignment = data.assignment;
        this.meta = data.meta;
        this.assignmentMode = data.assignment.settings.type;
    }
    /** returns the correct answer for the given pin */
    correctAnswerForPin(pinId) {
        return assignment_1.AssignmentMeta.correctAnswerForPin(this.meta, pinId);
    }
    checkAnswer(pinId, answer) {
        const pin = assignment_1.AssignmentUtils.pin(this.assignment, pinId);
        if (!pin)
            return undefined;
        const getCorrectAnswer = this.correctAnswerForPin(pin._id);
        const hasCorrectAnswer = !lodash_1.default.isEmpty(getCorrectAnswer);
        switch (pin.type) {
            case 'OPEN_QUESTION':
                if (!hasCorrectAnswer)
                    return undefined;
                return common_1.OpenQuestion.Answer.resultForAnswer(answer, pin, getCorrectAnswer, this.assignmentMode);
            case 'MULTIPLE_CHOICE':
                const correctAnswer = hasCorrectAnswer
                    ? getCorrectAnswer
                    : 'hasNoCorrectAnswer';
                return common_1.QuizQuestion.Answer.resultForAnswer(answer, correctAnswer, this.assignmentMode);
            case 'DRAG_QUESTION':
                if (!hasCorrectAnswer)
                    return undefined;
                return common_1.DragQuestion.Answer.resultForAnswer(answer, getCorrectAnswer);
            default:
                return undefined;
        }
    }
    // pointsForPinEntry(pin: AssignmentPin, pinEntry?: AnyPinEntry): number {
    //   if(!pin || !pinEntry) return 0;
    //   switch (pinEntry.type) {
    //     case 'OPEN_QUESTION':
    //       return OpenQuestion.Answer.rankingPointsForResult(pinEntry.result);
    //     case 'MULTIPLE_CHOICE':
    //       return QuizQuestion.Answer.rankingPointsForResult(pinEntry.result);
    //     case 'DRAG_QUESTION':
    //       return DragQuestion.Answer.rankingPointsForResult(pinEntry.result);
    //     default:
    //       return 0;
    //   }
    // }
    scoreForPinEntry(pin, pinEntry) {
        const noScore = { points: 0, timeSpent: 3000 }; // time penalty?
        if (!pin || !pinEntry)
            return noScore;
        const seenAt = pinEntry.seenAt || 0;
        switch (pinEntry.type) {
            case 'OPEN_QUESTION':
                return {
                    points: common_1.OpenQuestion.Answer.rankingPointsForResult(pinEntry.result),
                    timeSpent: (pinEntry.answer && pinEntry.answer.modifiedAt) || 0 - seenAt,
                };
            case 'MULTIPLE_CHOICE':
                return {
                    points: common_1.QuizQuestion.Answer.rankingPointsForResult(pinEntry.result),
                    timeSpent: (pinEntry.answer && pinEntry.answer.modifiedAt) || 0 - seenAt,
                };
            case 'DRAG_QUESTION':
                return {
                    points: common_1.DragQuestion.Answer.rankingPointsForResult(pinEntry.result),
                    timeSpent: (pinEntry.answer && pinEntry.answer.modifiedAt) || 0 - seenAt,
                };
            default:
                return noScore;
        }
    }
    suggestedPointForEntry(pin, answer) {
        if (!pin || !answer || !pin.settings.testPoints)
            return 0;
        const maxPoints = pin.settings.testPoints;
        switch (pin.type) {
            case 'OPEN_QUESTION':
                return common_1.OpenQuestion.Answer.testPointsForResults(maxPoints, this.checkAnswer(pin._id, answer));
            case 'MULTIPLE_CHOICE':
                return common_1.QuizQuestion.Answer.testPointsForResult(maxPoints, this.checkAnswer(pin._id, answer));
            case 'DRAG_QUESTION':
                return common_1.DragQuestion.Answer.testPointsForResult(maxPoints, this.checkAnswer(pin._id, answer));
            default:
                return 0;
        }
    }
    // points for one entry
    scoreForAssignmentEntry(entry) {
        const pinScores = assignment_1.AssignmentUtils.unorderedPins(this.assignment).map((pin) => {
            const pinEntry = entries_1.AssignmentEntry.entryForPin(entry, pin._id);
            return this.scoreForPinEntry(pin, pinEntry);
        });
        return {
            points: lodash_1.default.sumBy(pinScores, (s) => s.points),
            timeSpent: lodash_1.default.sumBy(pinScores, (s) => s.timeSpent),
            displayName: entry.displayName,
            userId: entry.userId,
        };
    }
    // map of studetns with scores, TODO: add time element
    rankingForAssignmentEntries(entries) {
        const scores = entries.map((entry) => this.scoreForAssignmentEntry(entry));
        return {
            scores: lodash_1.default.orderBy(scores, ['points', 'timeSpent'], ['desc', 'asc']),
        };
    }
    // answers for all pins for all students
    checkAssignmentEntries(entries) {
        const pins = assignment_1.AssignmentUtils.pinsByAssignmentType(this.assignment);
        return lodash_1.default.flatMap(pins, (pin) => this.checkPinEntries(pin._id, entries));
    }
    // answers for all pins for one students
    checkAssignmentEntry(entry) {
        return this.checkAssignmentEntries([entry]);
    }
    // answer for one pin and all student
    checkPinEntries(pinId, entries) {
        const results = entries.map((entry) => this.checkPinEntry(pinId, entry));
        return lodash_1.default.compact(results);
    }
    // answer for one pin and student
    checkPinEntry(pinId, entry) {
        const pin = assignment_1.AssignmentUtils.pin(this.assignment, pinId);
        if (!pin)
            return undefined;
        const pinEntry = entries_1.AssignmentEntry.entryForPin(entry, pin._id);
        const answer = entries_1.AssignmentEntry.answerForPin(entry, pinId);
        const previousResult = entries_1.AssignmentEntry.resultForPin(entry, pinId);
        const result = this.checkAnswer(pinId, answer);
        if (!result) {
            return undefined;
        }
        // fake complete answer
        if (pinEntry) {
            pinEntry.result = result;
        }
        const points = pin.settings.testPoints ? this.suggestedPointForEntry(pin, pinEntry && pinEntry.answer) : undefined;
        return {
            answer,
            result,
            userId: entry.userId,
            previousResult,
            pinId: pin._id,
            pinType: pin.type,
            points,
        };
    }
}
exports.AnswerBook = AnswerBook;
//# sourceMappingURL=AnswerBook.js.map